import { AppState } from '../store';

export const searchValueSelector = (state: AppState) =>
  state.searchCustomers.searchValue;

export const searchResultsSelector = (state: AppState) =>
  state.searchCustomers.searchResults;

export const searchCustomersStateSelector = (state: AppState) =>
  state.searchCustomers.searchCustomersState;
